import { styled } from '@mui/system'
import { colors, fontSizes } from '../../../Components/consts'
import { Head } from '../../../Components/Typography/Text.styles'

export const WeekendCardRoot = styled('div')(({ theme }) => ({
  position: 'relative',
  backgroundColor: colors.offWhite,
  borderRadius: theme.shape.borderRadius,
  overflow: 'hidden',
  marginBottom: theme.spacing(3),
}))

export const SideBarIndicator = styled('div')({
  position: 'absolute',
  top: 0,
  left: 0,
  width: 8,
  height: '100%',
  background: `linear-gradient(to bottom, ${colors.offWhite}, ${colors.gold})`,
})

export const CardContent = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(3),
  padding: theme.spacing(4),
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginLeft: theme.spacing(2),
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(3),
  },
}))

export const EventInfoWrapper = styled('div')({
  flex: 1,
})

export const EventHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(2),
  marginBottom: theme.spacing(2),
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
}))

export const EventLocation = styled(Head)(({ theme }) => ({
  fontWeight: 'bold',
  fontSize: fontSizes.large,
  paddingLeft: theme.spacing(2),
  [theme.breakpoints.down('md')]: {
    fontSize: fontSizes.semiLarge,
  },
}))

export const HomecomingBadge = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  fontSize: fontSizes.small,
  fontWeight: 500,
  width: 30,
  height: 'auto',
  img: {
    marginRight: theme.spacing(0),
  },
}))

export const EventDetails = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}))

export const DetailItem = styled('div')<{ sideMargins?: number }>(({ theme, sideMargins }) => ({
  display: 'flex',
  alignItems: 'center',
  marginLeft: theme.spacing(sideMargins || 0),
  svg: {
    marginRight: theme.spacing(1),
    color: colors.gray.gray90,
  },
  '& p': {
    fontSize: fontSizes.small,
  },
}))

export const ActionsWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  [theme.breakpoints.down('md')]: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
}))

export const HomecomingDetailsMobile = styled('div')(({ theme }) => ({
  display: 'none',
  [theme.breakpoints.down('md')]: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
  },
}))
